import React, { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { fetchChallenges } from '../api';
import { ChallengeCreate } from '../partials/ChallengeCreate';
import { ChallengeList } from '../partials/ChallengeList';
import { actions } from '../_redux';
import { merchantActions } from '../../../../redux/merchants';

import { PostMessagesHandler } from '../../Feed/lib/post-messages-handler';
import { hideWidget, loadWidget } from '../../../lib/widget-loader';

export const ChallengesPage = () => {
	const postMessageHandler = new PostMessagesHandler();
	const { filter, challenges } = useSelector(
		state => ({
			filter: state.merchants.filter,
			challenges: state.challenges.challenges,
		}),
		shallowEqual,
	);
	const dispatch = useDispatch();

	const fetch = async (filter) => {
		const res = await fetchChallenges(filter);
		const { challenges, challengesParticipations } = res;
		dispatch(
			merchantActions.updateLoading({
				isCalendarLoading: false
			}),
		);
		if (!challenges || !challenges.length) {
			dispatch(actions.setChallenges([]));
			return;
		}
		challenges.forEach((challenge) => {
			challenge.count = 0;
			const foundParticipation = challengesParticipations.find((participation) => {
				return participation._id === challenge._id
			});
			if (foundParticipation) {
				challenge.count += foundParticipation.count;
			}
		});
		dispatch(actions.setChallenges(challenges));
	};

	React.useEffect(() => {
		fetch(filter, dispatch);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [filter]);
	const merchantId = filter.merchantId;
	useEffect(() => {
		if (!merchantId || merchantId === 'all') {
			return;
		}
		loadWidget(merchantId);
	}, [merchantId]);

	useEffect(() => {
		postMessageHandler.subscribe();

		return function cleanup() {
			hideWidget();
			postMessageHandler.destroy();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			<ChallengeCreate fetchChallenges={() => fetch(filter)} />
			<ChallengeList challenges={challenges} />
		</>
	);
};
